
import Guard from '../services/auth'

export default [
    {
        path: '/enviar-mensagem', name: 'enviar-mensagem',
        component: () => import('@/views/mensagens/EnviarMensagemPrincipal.vue'),
        beforeEnter: Guard.redirectIfNotAuthenticated,
        meta: {pageTitle: 'Mensagens', breadcrumb: [{ text: 'Enviar Mensagem',active: true }], permissoes: 0},
    },
    {
        path: '/modelo-mensagem', name: 'modelo-mensagem',
        component: () => import('@/views/mensagens/modelos/ModeloMensagemPrincipal.vue'),
        beforeEnter: Guard.redirectIfNotAuthenticated,
        meta: {pageTitle: 'Modelo Mensagens', breadcrumb: [{ text: 'Enviar Mensagem',active: true }], permissoes: 0},
    },
    {
        path: '/logs-mensagem', name: 'logs-mensagem',
        component: () => import('@/views/mensagens/logs/LogsPrincipal.vue'),
        beforeEnter: Guard.redirectIfNotAuthenticated,
        meta: {pageTitle: 'Logs Mensagens Automáticas', breadcrumb: [{ text: 'Logs',active: true }], permissoes: 0},
    },

]
